// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"64f44cb0","221":"92172f73","294":"d2eb5c8b","357":"2c066e4a","371":"cb229b7a","453":"eb9b73df","576":"2d1675bd","615":"5a027336","722":"719e082b","823":"1ca0b41a","832":"67c8e907","855":"4c1b66de","858":"d5051265","918":"2f845819"}[chunkId] + ".chunk.js";
};